export enum InsuranceStatus {
    Draft,
    Active,
    Cancelled,
    Expired
}